<template>
  <button
    class="cruise-slider-arrow tw-w-full tw-absolute tw-left-0 tw-z-2"
    :class="[`cruise-slider-arrow--${arrowType}`]"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  name: "CruiseSliderArrowButton",

  props: {
    arrowType: {
      type: String,
      required: false,
      default: 'bottom',
    },
  },
}
</script>

<style lang="scss" scoped>
@import "CruiseSliderArrowButton";
</style>
